function onPageShow() {
    if (pageTransitionEnabled && pageTransition) {
        pageTransition.enter(function () {
            window.dispatchEvent(new Event('transitionDone'));
        });
    } else {
        window.dispatchEvent(new Event('transitionDone'));
    }
}
